import {
  FETCH_FEATURE_FLAGS_BEGIN,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE,
} from '../actions/featureFlags';

export const initialState = {
  error: null,
  isFetching: false,
  disableSocialSignup: false,
  inlineEmailEdit: false,
  nistPasswordV2: false,
  cashbackWidgetV2: false,
  countryWorkProfile: false,
  fragno1: false,
};

const featureFlags = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_FEATURE_FLAGS_BEGIN:
      return {
        ...state,
        error: null,
        isFetching: true,
      };
    case FETCH_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        available: true,
        disableSocialSignup: action.payload
          ? !!action.payload.axp_182_remove_social_signup
          : false,
        axp_779_verifications_emails_api: action.payload
          ? !!action.payload.axp_779_verifications_emails_api
          : false,
        inlineEmailEdit: action.payload
          ? !!action.payload.axp_967_inline_email_edit
          : false,
        nistPasswordV2: action.payload
          ? !!action.payload.axp_1295_nist_password_api_v2
          : false,
        cashbackWidgetV2: action.payload
          ? !!action.payload.cashback_widget_v2
          : false,
        countryWorkProfile: action.payload
          ? !!action.payload.org_1811_country_work_profile
          : false,
        fragno1: action.payload
          ? !!action.payload.axp_1845_fragno_one_redesign
          : false,
        error: null,
        isFetching: false,
      };
    case FETCH_FEATURE_FLAGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default featureFlags;
